import {
  PageAnalysisCautionCategory,
  PageAnalysisConfidence,
  PageViewsPeriod,
  PageViewsTab,
  RouteKind,
} from "@/types/admin/page-views";

export const PAGE_VIEWS_TABS: PageViewsTab[] = [
  { id: "traffic",  label: "Page traffic",                   genieIcon: "eye" },
  { id: "analysis", label: "Unused pages — Smart analysis", genieIcon: "brain" },
];

export const DEFAULT_TAB = "traffic";

export const PERIOD_OPTIONS: { value: PageViewsPeriod; label: string }[] = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
];

export const ROUTE_KIND_LABELS: Record<RouteKind, string> = {
  feature: "Feature",
  public: "Public",
  "per-genie": "Per genie",
  system: "System",
  redirect: "Redirect",
  internal: "Internal",
};

export const ROUTE_KIND_CHIP_STYLES: Record<RouteKind, string> = {
  feature: "bg-genie-primary/10 text-genie-primary",
  public: "bg-genie-secondary/10 text-genie-secondary",
  "per-genie": "bg-gradient-to-r from-[#4E9CFF]/15 to-[#FF4DB8]/15 text-[#222B45]",
  system: "bg-gray-100 text-gray-600",
  redirect: "bg-gray-100 text-gray-600",
  internal: "bg-gray-100 text-gray-600",
};

export const CONFIDENCE_STYLES: Record<PageAnalysisConfidence, { label: string; className: string }> = {
  high: { label: "High confidence", className: "bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] text-white" },
  medium: { label: "Medium confidence", className: "bg-genie-secondary/10 text-genie-secondary" },
  low: { label: "Low confidence", className: "bg-gray-100 text-gray-600" },
};

export const CAUTION_CATEGORY_LABELS: Record<PageAnalysisCautionCategory, string> = {
  "critical-flow": "Critical flow",
  "deep-link-only": "Deep-link only",
  "sub-page": "Sub-page of a busy page",
  "insufficient-data": "Not enough data yet",
  other: "Keep",
};

export const ANALYSIS_STEPS = [
  "Matching every visited URL to its route…",
  "Setting aside per-genie, system and redirect paths…",
  "Working out what each feature page is for…",
  "Comparing each page with its siblings and parents…",
  "Weighing links, navigation and tracking coverage…",
];

export const formatNumber = (value: number) => value.toLocaleString();

export const formatDay = (value: string | null) =>
  value
    ? new Date(`${value}T00:00:00Z`).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" })
    : "Never";
